// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "react-quill/dist/quill.snow.css";
import "./style.scss";

// MARK: Components
import TextField from "../../../../components/TextField";
import ImageCase from "../../../../components/ImageCase";
import Button from "../../../../components/Button";
import Divider from "../../../../components/Divider";
import ReactQuill from "react-quill";

// MARK: Stores
import OfferStore from "../../../../stores/OfferStore";
import { routerStore } from "../../../../stores/_rootStore";

// MARK: Resources
import strings from "../../../../resources/strings";
import { match as Match } from "react-router";

interface IProps {
	offerStore: OfferStore;
	match: Match<{ offerId?: string }>;
}

@inject("offerStore")
@observer
export default class OfferCreateOrEdit extends React.Component<IProps> {
	public componentDidMount = async () => {
		const offerId = this.props.match.params.offerId;
		if (offerId) {
			await this.props.offerStore.getOffer(offerId);
		}
	}

	public render() {
		const { offerStore } = this.props;
		return (
			<div className="offerCreateOrEdit">
				{!offerStore.loading && (
					<div className="offerCreateOrEditWrapper">
						<h1 className="offerCreateOrEditTitle">{offerStore.selectedOffer ? strings.offers.createOrEdit.title.edit : strings.offers.createOrEdit.title.new}</h1>
						<div className="offerFormContainer">
							<h2>{strings.offers.createOrEdit.sections.data}</h2>
							<TextField
								label={strings.offers.createOrEdit.fields.nick}
								name="nick"
								value={offerStore.nick}
								onChange={offerStore.handleValueChange}
								disabled={offerStore.loading}
								required={true}
							/>
							<TextField
								label={strings.offers.createOrEdit.fields.name}
								name="name"
								value={offerStore.name}
								onChange={offerStore.handleValueChange}
								disabled={offerStore.loading}
								required={true}
							/>
							<TextField
								label={strings.offers.createOrEdit.fields.url}
								name="url"
								value={offerStore.url}
								onChange={offerStore.handleValueChange}
								disabled={offerStore.loading}
							/>
							<TextField
								label={strings.offers.createOrEdit.fields.description}
								name="description"
								multiline={true}
								value={offerStore.description}
								onChange={offerStore.handleValueChange}
								disabled={offerStore.loading}
							/>
							<h1
								className="offerDescriptionLabel"
							>{strings.offers.createOrEdit.fields.descriptionHtml}
							</h1>
							<ReactQuill
								modules={offerStore.editorModules}
								value={offerStore.descriptionHtml}
								ref={offerStore.setQuillRef}
								onChange={offerStore.handleBodyHtmlChange}
							/>
						</div>
						<Divider className="divider" />
						<ImageCase
							title={strings.offers.createOrEdit.fields.imageTitle}
							onAddItem={offerStore.imageService.selectSingleImage}
							onRemoveItem={offerStore.imageService.removeImage}
							onReloadItem={offerStore.imageService.reloadImage}
							imageUploaders={offerStore.imageService.singleImageUploader}
						/>
						<div className="buttonsContainer">
							<Button
								onClick={() => offerStore.createOrEditOffer()}
								style={{ backgroundColor: "#0081B0", color: "white" }}
							>
								{strings.offers.createOrEdit.buttons.save}
							</Button>
							<Button
								onClick={() => routerStore.push("/dashboard/offers")}
							>
								{strings.offers.createOrEdit.buttons.back}
							</Button>
						</div>
					</div>
				)}
			</div>
		);
	}
}
